import React, { useEffect, useState } from "react";
import { SectionTitle } from "./_components/SectionTitle";
import { CustomAccordion } from "./_components/CustomAccordion";
import {
  Breadcrumb,
  BreadcrumbEllipsis,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "src/components/ui/breadcrumb";
import { Link } from "react-router-dom";
import StarRating from "../../components/StarRating";
import { Card } from "../../components/ui/card";
import { motion } from "framer-motion";
import { BaseUrlApi, ErrorMessage, UrlImage } from "../../lib/api";
import axios from "axios";
import { toast } from "sonner";
import { Avatar } from "antd";
import { cn } from "../../lib/utils";
import { Skeleton } from "src/components/ui/skeleton";

export default function MainStuRate() {
  const [reviews, setReviews] = useState([]);
  const [loadingReviews, setLoadingReviews] = useState(true);
  const fetchReviews = async () => {
    try {
      const { data } = await axios.get(`${BaseUrlApi}/reviews/site`);
      setReviews(data.data);
    } catch (error) {
      const msg = ErrorMessage(error);
      if (typeof msg === "string")
        toast("Error", { description: msg, status: "error" });
    } finally {
      setLoadingReviews(false);
    }
  };

  useEffect(() => {
    fetchReviews();
  }, []);

  return (
    <div className="space-y-20 max-w-7xl mx-auto px-4 mt-14">
      <div className="space-y-6">
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to="/">الصفحة الرئيسية</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>

            <BreadcrumbSeparator />

            <BreadcrumbItem>
              <BreadcrumbPage className="font-semibold">
                أراء الطلاب
              </BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>

        <SectionTitle title={"أراء الطلاب عنا 🌹"} />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {loadingReviews
          ? Array(4)
              .fill(0)
              .map((_, index) => <Skeleton className="w-full h-40" />)
          : reviews.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.2 }}
              >
                <RatingCard
                  rating={item.rate}
                  message={item.message}
                  image={item.reviewer?.image}
                  name={item.reviewer?.name}
                />
              </motion.div>
            ))}
      </div>
    </div>
  );
}

const RatingCard = ({ rating, message, image, name }) => {
  return (
    <Card className="p-6 grid grid-cols-1 md:grid-cols-3 items-center gap-4">
      <div className="flex flex-col gap-2 col-span-2">
        <div className="flex items-center gap-4 justify-between flex-wrap">
          <p className="font-bold text-xl flex-1 truncate">{name}</p>
          <StarRating rating={rating} />
        </div>
        <p className="font-semibold text-sm text-muted-foreground leading-relaxed">
          {message}
        </p>
      </div>

      <div className="flex items-center justify-center">
        <Avatar
          className={cn(
            "min-w-32 min-h-32 rounded-full flex items-center justify-center text-xs font-medium",
            "bg-blue-100 text-blue-600",
            "dark:bg-blue-900 dark:text-blue-300 text-lg"
          )}
          src={`${UrlImage}${image}`}
        >
          {name?.split(" ")[0]}
        </Avatar>
      </div>
    </Card>
  );
};
